<template>
  <div>
    <div class="back">
      <div class="body">
        <div style="color:#000000;font-size:16px;">
        </div>
        <div class="headback">
          <div class="c2" v-for="(item,index) in [0,1,2,3]"  :key="index" @click="changepowder(index)">
            <img  v-if="selectedpowder.length>index && selectedpowder[index]&&selectedpowder[index].picture"  :src="$prefix+selectedpowder[index].picture.path" height="250px">
            <i class="el-icon-close" v-if="selectedpowder[index]"  @click.stop="deletePowder(index)" style="color:#ffffff;position: absolute;z-index:99999999"></i>
            <img  v-if="!selectedpowder[index]"  src="@/assets/images/nopic.png">
            <div v-if="selectedpowder.length>index&&selectedpowder[index]" style="position:relative;left:25%"><div class="cname2">{{selectedpowder[index].name}}</div></div>
            <div v-if="!selectedpowder[index]" style="position:relative;left:25%">
              <div v-if="index==0" class="cname2">{{$t('surong.pleaseSelectCoffeeBeans')}}</div>
              <div v-if="index==1||index==2" class="cname2">{{$t('surong.pleaseSelectInstantPowder')}}</div>
              <div v-if="index==3" class="cname2">{{$t('surong.pleaseSelectFreshMilk')}}</div>
            </div>
          </div>
        </div>
        <div class="bodyback" v-show="false">
          <div class="c1" v-for="(item,index1) in drinks" :key="index1">
              <div v-for="(item2,index2) in item" :key="index2" style="height:150px;float:left">
                <div class="drinkback"  >
                  <img v-if="item2.cup&&item2.cup.picture" :src="$prefix+item2.cup.picture.path" @click="selectcup(index1,index2)" class="dinkpic">
                  <img v-else src="@/assets/images/plus.png"  class="nopic" @click="selectnewdrink(index1,index2)">
                </div>
                 <el-tooltip class="item" v-if="item2.cup" effect="dark" :content="item2.cup.name" placement="top-start">
                <div  class="cnamehide" >{{item2.cup.name}}</div>
                 </el-tooltip>
              </div>
          </div>
          <div style="text-align: center">
            <div   @click="getAllPostData()" style="display: inline-block;cursor: pointer;line-height: 40px;background-color: #805451;color: #fff;border-radius: 20px;padding: 0 20px">{{$t('save')}}</div>
          </div>
        </div>
      </div>

    </div>

    <el-dialog
      width="50%"
      :title="$t('stc.selectIngredient')"
      :visible.sync="allvisible"
      :close-on-click-modal="false"
      append-to-body
   >
      <div class="powderlist">
        <el-radio-group v-model="radio" style="width: 100%;" v-if="powderindex == 0">
          <div class="c2" v-for="(item,index) in coffeeBees" :key="index" @click="changeallpowder(item.id)">
            <img v-if="item.picture" :src="$prefix+item.picture.path" width="100px" height="200px">
            <div style="position:relative;left:25%;margin-top: 10px"><div class="cname2" style="font-size:16px" v-if="item.name"></div></div>
            <el-radio  :label="item.id">{{item.name}}</el-radio>
          </div>
        </el-radio-group>

        <el-radio-group v-model="radio" style="width: 100%;" v-if="powderindex == 1 || powderindex == 2">
          <div class="c2" v-for="(item,index) in powderCata" :key="index" @click="changeallpowder(item.id)">
            <img v-if="item.picture" :src="$prefix+item.picture.path" width="100px" height="200px">
            <div style="position:relative;left:25%;margin-top: 10px"><div class="cname2" style="font-size:16px" v-if="item.name"></div></div>
            <el-radio  :label="item.id">{{item.name}}</el-radio>
          </div>
        </el-radio-group>

        <el-radio-group v-model="radio" style="width: 100%;" v-if="powderindex == 3">
          <div class="c2" v-for="(item,index) in milks" :key="index" @click="changeallpowder(item.id)">
            <img v-if="item.picture" :src="$prefix+item.picture.path" width="100px" height="200px">
            <div style="position:relative;left:25%;margin-top: 10px"><div class="cname2" style="font-size:16px" v-if="item.name"></div></div>
            <el-radio  :label="item.id">{{item.name}}</el-radio>
          </div>
        </el-radio-group>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allvisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="selectpowder()">{{$t('okSpace')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="50%"
      :title="$t('surong.listOfDrinkCups')"
      :visible.sync="beverageallVisible"
      :close-on-click-modal="false"
      append-to-body
   >
            <el-row :gutter="24" class="row">
                <el-col :span="24">
                    <el-table
                        ref="multipleTable"
                        :data="filterbevarage"
                        tooltip-effect="dark"
                        page-size="1"
                        stripe
                        max-height="520"
                        @select="handleSelection"
                        @selection-change="handleSelection"
                        :empty-text="$t('nodata')"
                        >
                        <el-table-column
                          type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                            type="index"
                            :label="$t('serialNo')"
                            width="80px"
                            >
                        </el-table-column>
                        <el-table-column
                          prop="name"
                          :label="$t('beverageName')"
                          >
                        </el-table-column>
                        <el-table-column
                          prop="type"
                          column-key="type"
                          :label="$t('surong.typeOfDrink')"
                          >
                          <template slot-scope="scope">
                            <span v-if="scope.row.type == 1">{{$t('surong.hotDrink')}}</span>
                            <span v-if="scope.row.type == 0">{{$t('surong.coldDrink')}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="$t('beverageImage')"
                          >
                          <template slot-scope="scope">
                            <el-image style="width: 100px; height: 100px" fit="fill" class="img" v-if="scope.row.picture" :src="scope.row.picture.path"></el-image>
                            <label v-else>{{$t('noPicture')}}</label>
                          </template>
                        </el-table-column>

                    </el-table>
                </el-col>
            </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allvisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="confirmCup()">{{$t('okSpace')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="50%"
      :title="$t('surong.pleaseSelectCupType')"
      :visible.sync="cupvisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="powderlist" >
        <div v-for="(item,index) in findcups" :key="index">
          <div class="c22" v-if="item.beverage">
            <img v-if="item.checkedPicture" :src="$prefix+item.checkedPicture.path" height="100" width="100">
            <img v-else src="@/assets/images/nopic.png" class="nopic">
            <div>
              <div class="cname" v-if="item.beverage&&item.cupSize">{{item.beverage.name}}</div>
              <!-- <div class="cname" v-if="item.cup.beverage&&item.cup.cupSize">{{item.cup.cupSize.name}}</div> -->
            </div>
            <div>
              <el-checkbox v-model="item.checked" @change="cupChooseChange(item)" style="margin: 10px 0 10px 0;">{{item.cupSize.name}}</el-checkbox>
            </div>
            <div v-if="item.checked">
              <el-radio-group v-model="item.concentration">
                <el-radio :label=0>{{$t('equipmentmanagement.normal')}}</el-radio>
                <el-radio :label=1>{{$t('equipmentmanagement.extraStrong')}}</el-radio>
                <el-radio :label=2>{{$t('equipmentmanagement.muchStronger')}}</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-top: 15px;" v-if="item.checked">
              <div style="display: inline-block;line-height: 30px;vertical-align: top;margin-right: 20px;padding-left: 20px;width:90%">
                <span style="margin-right:10px">{{$t('equipmentmanagement.fineAdjustmentOfCupVolume')}}:</span>
                <el-input v-model="item.cupAmountFineAdjustment" style="width:50%;margin-right:10px" @input="inputclick()" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>%
              </div>
            </div>
            <!-- <el-checkbox v-model="item.cupquantity" @change="cupChooseChange(item)">{{item.cupSize.name}}</el-checkbox> -->
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cupvisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="savecups()">{{$t('okSpace')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props:
        ['initvalue']
    ,
    name:"xianmConfig",
    data() {
      return {
        allvisible:false,
        beverageVisible:false,
        isFree:true,
        allpowder:[],
        selectedpowder:[],
        nowpowder:null,
        powderindex:-1,
        powderid:-1,
        radio:'',
        cups:[],
        drinks:[
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          ,{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}]
          ],
        allcuplist:[],
        cupvisible:false,
        drinkpostData: {
          keyConfigPostDatas:[],
          equipment_ID:0
        },
        cupid:-1,
        cupquantity: 1,
        cupindex1:-1,
        cupindex2:-1,
        BtnConfigList:[],
        price:'0.00',
        totalBtnConfigCount:0,
        cupAmountFineAdjustment1:100,
        list:[],
        powderData:[],
        allbeverages:[],
        beverageallVisible:false,
        coffeeBees:[],
        powderCata:[],
        milks:[],
        filterbevarage:[],
        cupdata:[],
        selectedCupTypeList:[],
        nowcup:[],
        findcups:[],
        truesort:0,
        cupchecked:false,
        indexx:0,
        indexy:0,
        newarr:[]
      }
    },
    mounted() {
      Promise.all([this.init1(),this.init2(),this.initpowder()]).then(res=>{
        this.loadBtnConfigListQC();
        this.$forceUpdate()
      })

    },
    methods:{
      init1(){
        return  this.$httpservice.get("api/Equipment/EquipmentChannels", {dtuNo:this.initvalue.dtuNumber}).then(res=>{
          this.powderData = res.body.data
          this.powderData.forEach(e=>{
            this.selectedpowder[e.sort-1] = e.rawMaterial
          })
        })
      },
      init2(){
        return this.$httpservice.get("api/Equipment/CupTypes", {pageIndex:0,pageSize:0,dtuNo:this.initvalue.dtuNumber}).then(res=>{
          this.allcuplist = res.body.data

          this.allcuplist.forEach(item => {
            if(!this.allbeverages.find(x=>x.id==item.beverage.id))
            {
                item.beverage.type = item.type
                this.allbeverages.push(item.beverage)
            }
          })
          console.log(this.allbeverages)
        })
      },
      initpowder(){
        return this.$httpservice.get("api/Equipment/RawMaterials", {equipmentId:this.initvalue.id}).then(res=>{
          this.allpowder= res.body.data

          //筛选粉盒类型
          this.coffeeBees = this.allpowder.filter(e=>{return e.rawMaterialCatalog == 0})
          this.powderCata = this.allpowder.filter(e=>{return e.rawMaterialCatalog == 1})
          this.milks = this.allpowder.filter(e=>{return e.rawMaterialCatalog == 2})
        })
      },
      //清空某个已选原料
      deletePowder(index){
        this.selectedpowder[index] = null
        this.$forceUpdate()
      },
      //获取按键信息
      loadBtnConfigListQC(){
        // this.menuConfigDialogVisible = true;
        let that = this;
        this.$httpservice.get("api/Equipment/KeyConfigs",{dtuNo:that.initvalue.dtuNumber}).then(
           (data) =>{
            if(data.body.code=="200"){
              that.list = data.body.data;
              // console.log(that.BtnConfigList)
              // let list =  that.BtnConfigList.filter(item=>{return item.cupType})
              if(that.list && that.list.length>0){
                for(let i in that.list){
                  //冷饮sort 0-60
                  // if(that.list[i].sort<100){
                    if(that.list[i].price>0){
                      that.isFree = false;
                    }
                    let drinksort = parseInt((that.list[i].sort-1)/3);
                    // console.log(drinksort)
                    let index1 = parseInt(drinksort/12)
                    let index2 = drinksort%12
                    //console.log(list[i])
                    // that.selectedpowder[index2] = that.list[i].cupType.beverage.rawMaterials[0]
                    that.cups.push({sort:that.list[i].sort,cup:that.list[i].cupType,checked:true,concentration:that.list[i].concentration,cupAmountFineAdjustment:that.list[i].cupAmountFineAdjustment,price:that.list[i].price})
                    that.newarr.push(Object.assign(that.list[i].cupType,{concentration:that.list[i].concentration,cupAmountFineAdjustment:that.list[i].cupAmountFineAdjustment,sort:that.list[i].sort}))
                    let nowcup = that.allcuplist.findIndex(x=>x.id == that.list[i].cupTypeID)
                    if(nowcup !=-1){
                    that.allcuplist[nowcup].cupAmountFineAdjustment = that.list[i].cupAmountFineAdjustment;
                    that.allcuplist[nowcup].concentration = that.list[i].concentration;
                    }

                    that.drinks[index1][index2].cupquantity = that.list[i].concentration;
                    that.drinks[index1][index2].cupAmountFineAdjustment = that.list[i].cupAmountFineAdjustment;
                    that.drinks[index1][index2].price = that.list[i].price;
                    that.drinks[index1][index2].cup = that.list[i].cupType.beverage;
                    that.$forceUpdate()
                }
                // console.log(that.newarr)
              }
            }else{
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      //点击选择原料
      changepowder(index){
        this.powderindex = index
        this.allvisible = true
        // this.powderid = this.selectedpowder[index].id
      },
      changeallpowder(id){
        this.nowpowder = this.allpowder.find(item=>{return item.id == id})
      },
      selectpowder(){
        this.allvisible = false
        // let find = this.allpowder.find(item=>{return item.id == this.powderid})
        this.selectedpowder[this.powderindex] = this.nowpowder
      },
      //获取已选择
      handleSelection (selection) {
        this.selectedCupTypeList=selection
      },
      //确认选择
      confirmCup(){
        this.beverageallVisible =false
        console.log(this.selectedCupTypeList[0])
        this.drinks[this.indexy][this.indexx].cup = this.selectedCupTypeList[0]
        // console.log(this.drinks)
        this.$forceUpdate()
      },
      //点击饮品图片选择杯型
      selectcup(index1,index2){
        this.nowcup = []
        // console.log(index1,index2)
        this.truesort = index2+index1*12 +1
        if(this.cups.find(x=>x.sort == this.truesort*3)){
          this.nowcup.push(this.cups.find(x=>x.sort == this.truesort*3))
        }
        if(this.cups.find(x=>x.sort == this.truesort*3-1)){
          this.nowcup.push(this.cups.find(x=>x.sort == this.truesort*3-1))
        }
        if(this.cups.find(x=>x.sort == this.truesort*3-2)){
          this.nowcup.push(this.cups.find(x=>x.sort == this.truesort*3-2))
        }

        if(this.nowcup.length>0){
          this.findcups = this.allcuplist.filter(x=>x.beverage.id == this.nowcup[0].cup.beverage.id)

          this.findcups.forEach(e=>{
            if(this.nowcup.find(x=>x.cup.id == e.id)){
              e.checked = true
            }else{
              e.checked = false
            }
          })
        }else{
          this.findcups =  this.allcuplist.filter(x=>x.beverage.id == this.drinks[index1][index2].cup.id)
          this.findcups.forEach(e=>{
            e.checked =false
          })
        }

        // console.log(this.findcups)
        this.cupvisible = true
      },
      //选择新的饮品
      selectnewdrink(index1,index2){
        this.indexx = index2
        this.indexy = index1
        // console.log(this.selectedpowder)
        //找所有包含已选原料的饮品
        this.filterbevarage = []
        this.selectedpowder.forEach(e=>{
          if(e){
            let data =this.allbeverages.filter(x=>x.rawMaterials.find(y=>y.id==e.id)!=null)
            this.filterbevarage = this.filterbevarage.concat(data)
          }
        })
        // console.log(this.filterbevarage)

        this.cupdata = []
        //排除包含未选择原料的饮品
        let nodrinks  =[]
        this.allpowder.forEach(e=>{
          if(this.selectedpowder.find(x=>x!=null&&x.id==e.id)==null){
            nodrinks.push(e)
          }
        })
        // console.log(nodrinks)

        let flag =true
        this.filterbevarage.forEach(e=>{
          flag =true
          e.rawMaterials.forEach(ee=>{
            let aa= nodrinks.find(x=>x.id==ee.id)
            if(aa){
              flag =false
            }
          })
          if(this.allcuplist.find(x=>x.beverage.id == e.id)!=null&&flag){
            this.allcuplist.forEach(a=>{
              if(a.beverage.id == e.id){
                if(!this.cupdata.find(y=>y.id == a.id)){
                  this.cupdata.push(a)
                }
              }

            })
          }
        })
        this.filterbevarage = []
        this.cupdata.forEach(e=>{
          this.filterbevarage.push(Object.assign(e.beverage,{type:e.type}))
        })
        this.filterbevarage = this.arrUnique(this.filterbevarage,"id")
        console.log(this.filterbevarage)
        this.beverageallVisible =true
      },
      arrUnique(arr, key) {
        let returnArr = [];
        if (key) {
          // 对象数组去重
          const obj = {};
          returnArr = arr.reduce((cur, next) => {
            if(obj[next[key]]){
              cur[cur.findIndex(item=>{return item.id == next[key]})] = next
            }else{
              obj[next[key]] = true
              cur.push(next);
            }
              return cur;
            }, []);
          return returnArr;
        }
      },
      cupChooseChange(e){
        // e.checked =!e.checked
        console.log(e)
        this.$forceUpdate()
        if(!e.checked){
          this.newarr = this.newarr.filter(item=>{return item.id != e.id})
        }
      },
      savecups(){
        // console.log(this.findcups)
        let configcups = this.findcups.filter(x=>x.checked == true);
        configcups.forEach((e,index)=>{
          configcups.cupAmountFineAdjustment = e.cupAmountFineAdjustment*1
          if(!e.sort){
            e.sort = this.truesort*3-2+index
          }
        })
        this.newarr =  this.newarr.concat(configcups)
        this.cupvisible = false
      },
      inputclick(){
        this.$forceUpdate()
      },
      //打包数据
      getAllPostData(){
        this.drinkpostData.keyConfigPostDatas = []
        this.newarr = this.arrUnique(this.newarr,"id")
        this.newarr.forEach(e => {
          if(e.id!= null){
            // this.drinkpostData.keyConfigPostDatas.push({sort: e.sort,cupType_ID:e.id,name:e.name,price:e.price,concentration:e.concentration,cupAmountFineAdjustment:e.cupAmountFineAdjustment});
            this.drinkpostData.keyConfigPostDatas.push({sort: e.sort,cupType_ID:e.id,name:e.beverage.name,concentration:e.concentration,cupAmountFineAdjustment:e.cupAmountFineAdjustment});
            this.drinkpostData.equipment_ID = parseInt(this.initvalue.id);
          }
        })
        this.saveData();
      },
      //保存
      saveData(){
        //保存通道数据
        // console.log(this.selectedpowder)
        let postData = new Object();
        postData.dtuNo = this.initvalue.dtuNumber;
        postData.equipmentChannels = [];
        this.selectedpowder.forEach((e,index)=>{
          postData.equipmentChannels.push({sort:index+1,rawMaterial_ID:e.id})
        })
        this.$httpservice.post("api/Equipment/UploadEquipmentChannel", postData).then(res=>{
          if(res.body.data.code == "200"){
            that.$message({
              message: that.$t('equipmentmanagement.channelInformationSavedSuccessfully'),
              type: 'success'
            });
          }
        })
        // let drinkpostData = new Object()
        if(this.drinkpostData !=null){
          let that = this;

          this.$httpservice.post("api/Equipment/AddKeyConfigs",this.drinkpostData).then(
            function (data) {
              if(data.body.code=="200"){
                that.loadBtnConfigListQC()
                that.$message({
                  message: that.$t('stc.newlyAddKeyConfigurationSuccessfully'),
                  type: 'success'
                });
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
                that.$message({
                  message: that.$t('queryFailedStatusCode')+statusCode,
                  type: 'warning'
                });
              }
            );
          }else{
            this.$message({
              message: this.$t('equipmentmanagement.pleaseCompleteTheConfigurationInformation'),
              type: 'warning'
            });
          }
      }
    }
  }
</script>
<style scoped>
  .back{
    padding: 20px;
    background: url("../../assets/images/equipment/background_pay.jpg");
    background-size: 100% 100%;
    text-align: center;
  }

  .body{
    display: inline-block;
    width: 100%;
  }
  .headback{
    background: url("../../assets/images/equipment/back_material.jpg");
    background-size: 100% 100%;
    overflow: hidden;
    padding: 10px 0px;
  }
  .c1{
    float: left;
    width: 100%;
    text-align: center;
  }
  .c2{
    float: left;
    width: 25%;
    text-align: center;
  }
  .c22{
    float: left;
    width: 30%;
    text-align: center;
  }
  .c1 img,.c2 img{
    width: 150px;
  }
  .cname{
    /* display: inline-block; */
    margin-left:35%;
    width: 80px;
    line-height: 25px;
    color: #2e2115;
    background: url("../../assets/images/equipment/tast_select_textview_back.png");
    background-size: 100% 100%;
    font-size: 12px;
  }
    .cnamehide{
    /* display: inline-block; */
    width: 80px;
    line-height: 25px;
    color: #2e2115;
    background: url("../../assets/images/equipment/tast_select_textview_back.png");
    background-size: 100% 100%;
    font-size: 12px;
    display:block;/*内联对象需加*/
    /* width:100px; */
    word-break:keep-all; /* 不换行 */
    white-space:nowrap; /* 不换行 */
    overflow:hidden; /* 内容超出宽度时隐藏超出部分的内容 */
    text-overflow:ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
  }
    .cname2{
    /* display: inline-block; */
    width: 120px;
    line-height: 25px;
    color: #2e2115;
    background: url("../../assets/images/equipment/tast_select_textview_back.png");
    background-size: 100% 100%;
    font-size: 12px;
  }
    .cnameyuan{
    display: inline-block;
    width: 70px;
    font-size: 12px;
    height: 25px!important;
  }
  .powderlist{
    overflow: hidden;
    max-height: 500px;
    overflow-y: auto;
  }
  .checked{
    position: absolute;
    left: 20px;
    top: 0px;
    width: 20px!important;
    height: 20px!important;
  }
  .checked2{
    position: absolute;
    right: -10px;
    top: 5px;
    width: 20px!important;
    height: 20px!important;
  }
  .bodyback{
    padding: 20px 0;
    background-color: #f7ebe1;
    overflow: hidden;
  }

  .drinkback{
    width: 78px;
    height: 100px;
    /* margin-bottom: 20px; */
    display: inline-block;
    cursor: pointer;
    border: 1px solid #4d556d;
    border-radius: 8px;
    margin: 0 5px 0px 5px;
  }
  .noneback{
    background: url("../../assets/images/equipment/add.png");
    background-size: 100% 100%;
  }
  .q1back{
    background: url("../../assets/images/equipment/background_normal.png");
    background-size: 100% 100%;
  }
  .q2back{
    background: url("../../assets/images/equipment/background_bold.png");
    background-size: 100% 100%;
  }
  .q3back{
    background: url("../../assets/images/equipment/background_more_bold.png");
    background-size: 100% 100%;
  }
  .quantity{
    display: inline-block;
    line-height: 30px;
    vertical-align: top;
    margin-right: 20px;
    width: 60px;
    text-align: center;
    background-size: 100% 100% !important;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .q1{
    background: url("../../assets/images/equipment/background_normal.png");
  }
  .q2{
    background: url("../../assets/images/equipment/background_bold.png");
  }
  .q3{
    background: url("../../assets/images/equipment/background_more_bold.png");
  }
  .dinkpic{
    display: inline-block;
    width: 80px!important;
    height: 80px!important;
    display: inline-block;
    margin-top: 10px;
  }

  .nopic{
    display: inline-block;
    width: 70px!important;
    height: 70px!important;
    display: inline-block;
    margin-top: 10px;
  }
  .el-input--small .el-input__inner {
    height: 22px!important;
    line-height: 32px;
  }
  .generateBtn{
    background-color: rgb(128, 84, 81);
    color: #ffffff;
    border-color: #ffffff;
    border-radius: 19px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/xianmoConfig.vue